import React from "react";
import { AlertTriangle, ShieldCheck, RefreshCw } from "lucide-react";

const CHECKS = [
  { n: "1", label: "Medication name", detail: "Match the generic name and, if listed, the brand name." },
  { n: "2", label: "Strength", detail: 'Compare "mg", "mcg", or "IU" exactly to the label.' },
  { n: "3", label: "Imprint on both sides", detail: "Read every letter and number on the front and back of the pill." },
  { n: "4", label: "Shape and dosage form", detail: "Tablet, capsule, softgel — and the pill's shape and color." },
  { n: "5", label: "Prescription label and manufacturer", detail: "Confirm the pharmacy label and manufacturer name." },
];

export default function SafetyCheckPanel({ largeText, onRefillCompare }) {
  return (
    <section
      data-testid="safety-check-panel"
      className="mt-8 bg-white border-2 border-[#2B5339] rounded-2xl p-6 sm:p-8 print:border print:shadow-none"
    >
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck size={18} className="text-[#2B5339]" />
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339]">
          Five-point safety check
        </div>
      </div>
      <p className={`text-[#1C2B23] leading-relaxed ${largeText ? "text-lg" : "text-sm"}`}>
        Before taking any dose, check these five things against the pharmacy label:
      </p>
      <ol className="mt-4 space-y-3">
        {CHECKS.map((c) => (
          <li key={c.n} className="flex gap-3 items-start">
            <div className="font-mono-num flex-shrink-0 w-7 h-7 rounded-full bg-[#E8F0EB] text-[#2B5339] font-semibold flex items-center justify-center text-sm">
              {c.n}
            </div>
            <div>
              <div className={`font-medium text-[#1C2B23] ${largeText ? "text-xl" : "text-base"}`}>
                {c.label}
              </div>
              <div className={`text-[#5C6B62] ${largeText ? "text-base" : "text-sm"}`}>
                {c.detail}
              </div>
            </div>
          </li>
        ))}
      </ol>
      <div className="mt-5 bg-[#FDF2ED] border border-[#F5C7B4] rounded-xl p-4 flex items-start gap-2">
        <AlertTriangle size={16} className="text-[#C26747] mt-0.5 flex-shrink-0" />
        <p className={`text-[#1C2B23] leading-relaxed ${largeText ? "text-base" : "text-sm"}`}>
          <strong>Never identify a medication using color or shape alone.</strong> Medication
          appearance may vary by manufacturer. If anything looks different or uncertain, do not take
          it until a pharmacist confirms it.
        </p>
      </div>
      {onRefillCompare && (
        <button
          data-testid="refill-different"
          type="button"
          onClick={onRefillCompare}
          className="mt-5 inline-flex items-center gap-2 bg-[#C26747] text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-[#A5533A] print:hidden"
        >
          <RefreshCw size={14} /> My refill looks different
        </button>
      )}
    </section>
  );
}
